import { IRootState } from './index';
import { LoginState } from './login.types';
import { RequestStatusType } from './fetch.types';

export const selectLogin = ({ login }: IRootState): LoginState => login;

export const selectIsLogin = ({ login }: IRootState): boolean => login.isLogged;
export const selectLoginRequestStatus = ({ login }: IRootState): RequestStatusType => login.request.status;
